import type { notification } from "antd";

import { createContext, useContext } from "react";

type NotificationApi = ReturnType<typeof notification.useNotification>[0];

interface NotificationsContextType {
  showNotifications: NotificationApi;
}

export const NotificationsContext =
  createContext<NotificationsContextType | null>(null);

export const useNotificationsContext = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error(
      "useNotificationsContext must be used within a NotificationsProvider",
    );
  }
  return context;
};
